
/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Azmat Siddique ",
  title: "Hi all, I'm Azmat Siddique",
  subTitle: emoji("A passionate Data Scientist 🚀 with strong math background and 2+ years of experience using predictive modeling, data processing, and data mining algorithms to solve challenging business problems. Involved in Python open source community and passionate about deep reinforcement learning.."),
  resumeLink: "https://drive.google.com/file/d/1f3UjK0Yvn_vVeSgTQZ7AyCBSOCFLXnQK/view?usp=sharing"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/azmatsiddique",
  linkedin: "https://www.linkedin.com/in/azmatsiddique/",
  gmail: "azmat.siddique.98@gmail.com",
  leetcode: "https://leetcode.com/azmatsiddique/",
  facebook: "https://www.facebook.com/azmat.siddique.98",
  stackoverflow: "https://stackoverflow.com/users/10535434/azmat-siddique",
  twitter:"https://twitter.com/azmatsiddique",
  instagram:"https://www.instagram.com/azmat_siddique/"
  // Instagram and Twitter are also supported in the links!
};

// Your Skills Section

const skillsSection = {
  title: "What i do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji("⚡ Identifying the data-analytics problems that offer the greatest opportunities to the organization"),
    emoji("⚡ Collecting large sets of structured and unstructured data from disparate sources"),
    emoji("⚡ Cleaning and validating the data to ensure accuracy, completeness, and uniformity"),
    emoji("⚡ Devising and applying models and algorithms to mine the stores of big data"),
    emoji("⚡ Analyzing the data to identify patterns and trends"),
    emoji("⚡ Interpreting the data to discover solutions and opportunities")
  ],

/* Make Sure You include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName:"Hadoop",
      fontAwesomeClassname:"fa-apple-pay"
    },
    {
      skillName:"Data Science",
      fontAwesomeClassname:"fas fa-dna"
    },
    {
      skillName:"Artificial Intelligence",
      fontAwesomeClassname:"fas fa-robot"
    }
  ]
};

// Your education background

const educationInfo = {
  viewEducation: true, // Set it to true to see education section
  schools: [
    {
      schoolName: "Kurukshetra University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "Augest 2014 - july 2018",
      
    }
  ]
}

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Data Science,ML & AI",  //Insert stack or technology you have experience in
      progressPercentage: "80%"  //Insert relative proficiency in percentage
    },
    {
      Stack: "Database",
      progressPercentage: "85%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    },
    {
      Stack: "Cloud Computing AWS &GCP",
      progressPercentage: "88%"
    }
  ]
};


// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Hadoop Developer",
      company: "Oracle KVCH",
      companylogo: require("./assets/images/KVCH-OG-TAG-LOGO.jpg"),
      date: "June 2019 – Present",
      descBullets: [
        "Client is an upscale department store chain in the United States. ",
        "The purpose of the project is to store terabytes of log information generated by the ecommerce website and extract meaningful information out of it. The solution is based on the open source Big Data s/w Hadoop. The data will be stored in Hadoop file system and processed using Hive which includes getting the raw html data from the websites, process the html to obtain product and pricing information, extract various reports out of the product, pricing information and export the information for further processing"
      ]
    },
    {
      role: "Hadoop Developer",
      company: "TcsION",
      companylogo: require("./assets/images/201708212323440581_TCS-iON-ICSI-ink-pact-for-digital-learning_SECVPF.gif"),
      date: "Aug 2018 – Dec 2019",
      descBullets:[ "I​n this project code has been developed for the purpose of helping the persons whowants to switch their data from structured to unstructured", 
      "storage like RDFS and HDFS. User can choose data file from any kind of database to get it converted in another database data file."
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "azmatsiddique", // Change to your github username to view your profile in Contact Section.
  showGithubProfile :"true" // Set true or false to show Contact profile using Github, defaults to false
};


// Some Big Projects You have worked with your company

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    
    
  ]
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {

  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google IT Automation Professional Certificate",
      subtitle: "This six-course certificate, developed by Google, is designed to provide IT professionals with in-demand skills -- including Python, Git, and IT automation -- that can help them advance their careers. The hands-on curriculum is designed to teach learners how to write code in Python, with a special focus on how this applies to automating tasks in the world of IT support and systems administration.",
      image: require("./assets/images/img.png"),
      footerLink: [
        { name: "Badge", url: "https://www.youracclaim.com/earner/earned/badge/d1850125-6850-4279-96fc-3278c8a4c816" },
        { name: "Certificate", url: "https://www.coursera.org/account/accomplishments/specialization/certificate/93QCLLVXAYFX" },
      ]
    },
    {
      title: "Google IT Support Professional Certificate",
      subtitle: "Those who earn the Google IT Support Professional Certificate have completed five-courses, developed by Google, that include hands-on, practice-based assessments and are designed to prepare them for entry-level roles in IT support. They are competent in foundational skills, including troubleshooting and customer service, networking, operating systems, system administration, and security.",
      image: require("./assets/images/rrr.png"),
      footerLink: [
        { name: "Badge", url: "https://www.youracclaim.com/earner/earned/badge/6b79ffa0-664c-4151-b0a7-665bd3152e18" },
        {name: "Certificate",url:"https://www.coursera.org/account/accomplishments/specialization/certificate/Z8R8487697QS"}
      ]
    },

    {
      title: "AWS Fundamentals Specialization",
      subtitle: "In this Specialization, learners gained proficiency in essential concepts,services, and use cases within the Amazon Web Services (AWS) cloud ecosystem, including core AWS services and key AWS security concepts. The Specialization also covered fundamental strategies for planning and migrating existing workloads to AWS and how to build and deploy serverless applications with AWS. Learners are given opportunities to solidify their understanding by engaging in varioushands-on labs and exercises throughout the Specialization.",
      image: require("./assets/images/download.png"),
      footerLink: [
        { name: "Certification", url: "https://www.coursera.org/account/accomplishments/specialization/certificate/FB38SC2NBKD7" },
      ]
    }
  ]
};

// Blogs Section

// const blogSection = {

//   title: "Blogs",
//   subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

//   blogs: [
//     {
//       url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
//       title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
//       description: "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
//     },
//     {
//       url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
//       title: "Why REACT is The Best?",
//       description: "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
//     }
//   ]
// };

// Talks Sections

// const talkSection = {
//   title: "TALKS",
//   subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),

//   talks: [
//     {
//       title: "Build Actions For Google Assistant",
//       subtitle: "Codelab at GDG DevFest Karachi 2019",
//       slides_url: "https://bit.ly/saadpasta-slides",
//       event_url: "https://www.facebook.com/events/2339906106275053/"
//     }
//   ]
// };

// Podcast Section

// const podcastSection = {
//   title: emoji("Podcast 🎙️"),
//   subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

//   // Please Provide with Your Podcast embeded Link
//   podcast: ["https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"]
// };

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-9729037884",
  email_address: "azmat.siddique.98@gmail.com"
};

//Twitter Section

const twitterDetails = {

  userName : "azmatsiddique"//Replace "twitter" with your twitter username without @

};
export { greeting, socialMediaLinks, skillsSection, educationInfo, techStack, workExperiences, openSource, bigProjects, achievementSection, contactInfo , twitterDetails};
